export default {
  reservationStatus: {
    ACCEPTED: 'Bestätigt',
    PENDING: 'Ausstehend'
  }
}
